import { MapsAPILoader } from '@agm/core';
import { Component, ComponentFactoryResolver, ElementRef, NgZone, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { Subscription } from 'rxjs';
import { data } from '../../../../../shared/data/smart-data-table';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ClientListComponent implements OnInit {
  @ViewChild('vform') validationForm: FormGroup;
  @ViewChild("search") 
  public searchElementRef: ElementRef;

  @ViewChild(DatatableComponent) table: DatatableComponent;
  clientForm:FormGroup

  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = []; 
  imageUrl=environment.apiUrls.imageUrl;
  user_role: any
  client_id:any

  client_model ={
    name: '',
    description:'',
    type:'',
    startdate:'',
    enddate:'',
    status:'',
    budget:'',
    ownder:'',
    target:'',
    content:'',
    goals:'',
    kpi:'',
    url:'',
    trackingurl:'',
    results:'',
    analytics:'',
    attachments:'',
    references:'',
    notes: '',
    admin_notes: ''
  }
  minDate:any
  searchVal:any
  @ViewChild('name') inputName;

  address: string;
  latitude: number;
  longitude: number;
  zoom: number;
  private geoCoder;

  guideline_data:any
  pageNumberSubscription : Subscription
  read_passworrd:any
  edit_passworrd:any
  row_id:any
  row_data:any
  constructor(public apiService:ApiService,
              public toastr: ToastrService,
              private modalService: NgbModal,private mapsAPILoader: MapsAPILoader,
              private ngZone: NgZone,private spinner: NgxSpinnerService,
              private formBuilder : FormBuilder,private router : Router,
              private activatedRoute : ActivatedRoute, private store: Store<AppState>) { 

                this.user_role = JSON.parse(localStorage.getItem('user'))
                let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                let key_data = setting_data.filter((item) => item.key == 'Clients') 
                this.guideline_data = key_data[0]?._id
                this.locationAutoComplete()

                this.activatedRoute.queryParamMap.subscribe((params) => {
                  let page = +params.get('page');
                  this.setPage(page)
                });
                this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
                .subscribe(pageNumber => {
                  this.page.pageNumber = pageNumber;
                  if(pageNumber !==undefined){
                    this.page.pageNumber = pageNumber ?  pageNumber-1 :0
                  }
                });

              }

  ngOnInit() {
    this.getClientList()
    this.filterSetting('client_read_password')	
    this.filterSetting('client_edit_password')
    this.clientForm = this.formBuilder.group({
      name:  ['',],
      description: ['',],
      type: ['',],
      startdate: ['',],
      enddate: ['',],
      status: ['',],
      budget: ['',],
      ownder: ['',],
      target: ['',],
      content: ['',],
      goals: ['',],
      kpi: ['',],
      url: ['',],
      trackingurl: ['',],
      results: ['',],
      analytics: ['',],
      attachments: ['',],
      references: ['',],
      location: ['',],
      notes:  ['',],
      admin_notes:  ['',]
    })

    const today_date = new Date();
    this.minDate = today_date.toISOString().split('T')[0];
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getClientList() {
    this.spinner.show(undefined,
     {
       type: 'ball-triangle-path',
       size: 'medium',
       bdColor: 'rgba(0, 0, 0, 0.8)',
       color: '#fff',
       fullScreen: true
     });
   // let status = this.type_List.find((item) => item.name == this.activeTab);
   this.apiService.getAllClients(this.page.pageNumber+1,this.limitRef).subscribe((res: any) => {
     this.spinner.hide()
     this.rows = res?.data?.items
     this.page.totalPages=res?.data?.totalCount
   })
 }
 pageChangeData(page:any) {
  this.router.navigate([], {
    relativeTo: this.activatedRoute,
    queryParams: { page: page.offset +1 },
    queryParamsHandling: 'merge' // keep existing query params
  });
   this.apiService.getContactList(page.offset +1,page.pageSize).subscribe((res:any)=>{
    this.setPage(page.offset +1)
     this.rows =res.data.items
     this.page.totalPages=res.data.totalCount
   }) 
 }
 open(content, id,data) {
  this.locationAutoComplete()
  if(id !='' && data !=''){
    this.client_id =id
    this.client_model.name = data.name
    this.client_model.description = data.description
    this.client_model.type = data.type
    this.client_model.startdate = data.startdate
    this.client_model.enddate = data.enddate
    this.client_model.status = data.status
    this.client_model.budget = data.budget
    this.client_model.ownder = data.ownder
    this.client_model.target = data.target
    this.client_model.content = data.content
    this.client_model.goals = data.goals
    this.client_model.kpi = data.kpi
    this.client_model.url = data.url
    this.client_model.trackingurl = data.trackingurl
    this.client_model.results = data.results
    this.client_model.analytics = data.analytics
    this.client_model.attachments = data.attachments
    this.client_model.references = data.references
    this.client_model.notes = data.notes
    this.client_model.admin_notes = data.admin_notes

  }
  
  const modalOptions: NgbModalOptions = {
    size: 'lg' // 'sm', 'lg', or 'xl'
  };
    const modalRef = this.modalService.open(content,modalOptions);
    
    modalRef.result.then((result) => {
      this.client_id =''
      this.clientForm.reset()
      this.client_model.name =''
      this.client_model.description = ''
      this.client_model.type = ''
      this.client_model.startdate = ''
      this.client_model.enddate = ''
      this.client_model.status = ''
      this.client_model.budget = ''
      this.client_model.ownder = ''
      this.client_model.target = ''
      this.client_model.content = ''
      this.client_model.goals = ''
      this.client_model.kpi = ''
      this.client_model.url = ''
      this.client_model.trackingurl = ''
      this.client_model.results = ''
      this.client_model.analytics = ''
      this.client_model.attachments = ''
      this.client_model.references = ''
      this.client_model.notes = ''
      this.client_model.admin_notes = ''
    }, (reason) => {
      this.client_id =''
      this.clientForm.reset()
      this.client_model.name =''
      this.client_model.description = ''
      this.client_model.type = ''
      this.client_model.startdate = ''
      this.client_model.enddate = ''
      this.client_model.status = ''
      this.client_model.budget = ''
      this.client_model.ownder = ''
      this.client_model.target = ''
      this.client_model.content = ''
      this.client_model.goals = ''
      this.client_model.kpi = ''
      this.client_model.url = ''
      this.client_model.trackingurl = ''
      this.client_model.results = ''
      this.client_model.analytics = ''
      this.client_model.attachments = ''
      this.client_model.references = ''
      this.client_model.notes = ''
      this.client_model.admin_notes = ''
    });
 }
 submit(){
  
  if(!this.client_id){
    this.apiService.addClient(this.clientForm.value).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res.message)
        this.modalService.dismissAll()
        this.getClientList()
      }
      else this.toastr.error(res.error)
    })
  }
  if(this.client_id){
    this.client_model.startdate = this.clientForm.value.startdate
    this.client_model.enddate = this.clientForm.value.enddate
    this.apiService.updateClient(this.client_id,this.client_model).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success('update successfull!')
        this.modalService.dismissAll()
        this.getClientList()
      }
      else this.toastr.error(res.error)
    })
  }
 }
 clientDelete() {
  if (this.client_id) {
    this.apiService.deleteClient(this.client_id).subscribe((res: any) => {
      if (res.statusCode === 200) {
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.getClientList()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Erorr!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    })
  }
  else {
    this.toastr.error('something went wrong !!')
  }
}
// ================== Delete Alert ========================
ConfirmColor(id: any) {
  this.client_id = id
  swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to delete this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#2F8BE6',
    cancelButtonColor: '#F55252',
    confirmButtonText: 'Yes, delete it!',
    customClass: {
      confirmButton: 'btn btn-warning',
      cancelButton: 'btn btn-danger ml-1'
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      this.clientDelete()
    
    } else if (result.dismiss === swal.DismissReason.cancel) {
      swal.fire({
        title: 'Cancelled',
        text: 'Your imaginary file is safe :)',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success'
        },
      })
    }
  });
}
filter(val){
  this.apiService.filterClients(val).subscribe((res:any)=>{
    this.rows = res?.data
    this.page.totalPages = res?.data?.length
  })
}
resetFilter(){
 this.inputName.nativeElement.value = null;
 this.getClientList()

}
locationAutoComplete() {
  this.mapsAPILoader.load().then(() => {
    this.geoCoder = new google.maps.Geocoder;

    let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef?.nativeElement);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();
        this.address = place.formatted_address;
        console.log('address', this.address)
        // verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        // set latitude, longitude and zoom
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.zoom = 12;
        if(this.client_id){
          this.address = place.formatted_address;
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          // this.employee.address = this.address
          // this.employee.lat = this.latitude
          // this.employee.lng = this.longitude

        }
        console.log("lat lng",this.latitude,this.longitude)
      });
    });
  });
}
add(){
  this.router.navigate(['/business/add-client'])
}
edit(id){
  this.router.navigate(['/business/edit-client',id])
}
openDynamicModal(key_id:string) {
  const modalOptions: NgbModalOptions = {
    size: 'lg', // 'sm', 'lg', or 'xl'
    backdrop: 'static',
  };
  const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
  modalRef.componentInstance.key_id = key_id;
}
filterSetting(data) {
  this.apiService.searchSettings(data).subscribe((res: any) => {
      if(data ==='client_read_password') this.read_passworrd = res?.data?.items[0]?.value
      if(data ==='client_edit_password') this.edit_passworrd = res?.data?.items[0]?.value
  });
}
confirmPassword(id: any,) {
    this.row_id = id;
      swal
      .fire({
        text: "Please Enter Edit Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.passwordToEdit(result.value,id);
        }
        else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Cancel",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  confirmReadPassword(content: any,data) {
      swal
      .fire({
        text: "Please Enter Read Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.passwordToRead(result.value,content,data);
        }
        else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Cancel",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  passwordToEdit(password,id) {
    if(password === this.edit_passworrd){
      this.edit(id)
    }
    else {
      swal.fire({
        icon: "error",
        title: "Error!",
        text: "Incorrect Password!",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }

  }
  passwordToRead(password,content,data) {
    if(password === this.read_passworrd){
      this.openModal(content,data)
    }
    else {
      swal.fire({
        icon: "error",
        title: "Error!",
        text: "Incorrect Password!",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }

  }
  openModal(content,data){
    this.row_data = data;
    console.log('=>>',data)
    const options: NgbModalOptions = {
      size: "lg", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then(
      (result) => {
        this.row_data = null;
      },
      (reason) => {
        this.row_data = null;
      }
    );
  }
  gotoLink(id,prop){
    if(prop === 'lead'){
      window.open(`/leads/outsource-lead-edit/${id}`, '_blank');
    }
    if(prop === 'contract' || prop === 'product' || prop === 'project'){
      window.open(`/jobs/view/${id}`, '_blank');
    }
    // if(prop === 'product'){
    //   window.open(`/leads/outsource-lead-edit/${id}`, '_blank');
    // }
    // if(prop === 'project'){
    //   window.open(`/leads/outsource-lead-edit/${id}`, '_blank');
    // }
    
  }
}
